// @flow

import OrderShippingAddressRadio from './OrderShippingAddressRadio'

export default OrderShippingAddressRadio
